// import util from '../script/util';

/**
 * 分页混合
 * @type {{data(): *, methods: {handleSizeChange(*): void, handleCurrentPageChange(): void}, mounted(): void}}
 */
const pagination = {
  data() {
    return {
      page: {
        currentPage: 1, //当前页
        pageSize: 10, //每页条数
        // pageSize: 5,
        total: 0, //数据总条数,
        sizes: [10, 15, 20, 25, 30, 35, 40] //可选条目数
        // sizes: [5,10,15,20,25,30] //可选条目数
      },
      pageData: []
    };
  },
  methods: {
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.page.currentPage = 1;
      this.getTableData();
    },
    handleCurrentPageChange(val) {
      this.page.currentPage = val;
      this.getTableData();
    }
  },
  computed: {
    tableData() {
      // return util.isNotEmpty(this.pageData) ? this.pageData : [];
      return this.pageData
    }
  }
};

export {
  pagination
};



// WEBPACK FOOTER //
// ./src/assets/mixin/data-table.js